<template>
  <div class="container-fluid">
    <Card back>
      <template slot="header">
        <div class="row">
          <div class="col-12">
          <h3>پروفایل من <span class="h6" v-if="$store.state.LastLoginTime!=''">[ آخرین ورود به سامانه : {{$store.state.LastLoginTime}} ] </span></h3>

          </div>

        </div>
        <hr />
      </template>

      <template slot="content">
        <PersonelProfile v-if="$session.has('CustomerInfo')"></PersonelProfile>
        <div>
          <TanzimatUser v-if="!$session.has('CustomerInfo')"></TanzimatUser>
          <setting-ticket v-if="$session.has('CustomerInfo')"></setting-ticket>
          <TicketSignature v-if="!$session.has('CustomerInfo')"></TicketSignature>
        </div>
      </template>
    </Card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import PersonelProfile from './Components/PersonelProfile.vue'
import TanzimatUser from '@/pages/BnpSys/TanzimatUser.vue'
import TicketSignature from '../Support/TicketSignature.vue'
import SettingTicket from '../Support/SettingTicket.vue'
export default {
  data() {
    return {}
  },
  components: { Card, PersonelProfile, TanzimatUser, TicketSignature, SettingTicket },
}
</script>
<style scoped></style>
